import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import dateFormat from "dateformat";
import { utcToLocal } from "../../../helpers/DateHelper";
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function OnboardTable({
  module,
  data,
  loading,
  totalRows,
  page,
  limit,
  fetchData,
  openUpdateModal,
  openDeleteModal,
  handleView,
  isTrash,
  openOffboardModal,
}) {

  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{ ((page -1 ) * limit) + index +1 }.</div>,
      width: '100px'
    },
    {
      name: "Client",
      selector: (row) => row.client_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Requirement",
      selector: (row) => row.requirement_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Candidate",
      selector: (row) => row.candidate_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Mobile",
      selector: (row) => row.candidate_mobile,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "DOJ",
      selector: (row) => dateFormat(row.onboard_doj, 'dd/mm/yyyy'),
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Offboarded?",
      selector: (row) => row.onboard_is_offboard==1 ? 'Yes' : 'No',
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Last Working Day",
      selector: (row) => row.onboard_offboard_date ? dateFormat(row.onboard_offboard_date, 'dd/mm/yyyy') : '---',
      sortable: true, // ✅ enable sorting
    },
    // {
    //   name: "Added On",
    //   selector: (row) => utcToLocal(row.onboard_create_time)  
    // },
    // {
    //   name: "Last Edited On",
    //   selector: (row) => utcToLocal(row.onboard_update_time)
    // },
  ];

  if (! isTrash && (checkPermission(module.route, 'edit') || checkPermission(module.route, 'delete'))) {
    columns.push({
      name: "Action",
      right: "true",
      cell: row => <div className="hstack gap-2 fs-15">
                    {
                      row.onboard_is_offboard==0 ? <button type="button" className="btn btn-icon btn-sm btn-info" title="Off Board" onClick={() => openOffboardModal(row)}>
                      <i className='bx bxs-plane'></i>
                    </button> : ''
                    }
                    {checkPermission(module.route, 'edit') && <button type="button" className="btn btn-icon btn-sm btn-info" title="Edit" onClick={() => openUpdateModal(row)}>
                      <i className='bx bxs-edit'></i>
                    </button>}

                    {checkPermission(module.route, 'delete') && <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete" onClick={() => openDeleteModal(row)}>
                      <i className='bx bxs-trash'></i>
                    </button>}
                  </div>
    });
  }

  if (isTrash) {
    columns.push({
      name: "Deleted At",
      selector: (row) => utcToLocal(row.onboard_delete_time)
    });
  }

  const { theme, toggleTheme } = useTheme();

  const handlePageChange = async (page) => {
    fetchData(limit, page);
  };

  const handleLimitChange = async (newLimit, page) => {
    //if ((newLimit !== 10 && page !== 1) || localStorage.getItem(module.key)) {
      fetchData(newLimit, page);
    //}
  };

  // useEffect(() => {
  //   fetchData(limit, page);
  // }, []);

  createTheme("dark", {
    text: {
      primary: "#a2a3a4",
      secondary: "#2aa198",
    },
    background: {
      default: "#252729",
    },
    context: {
      background: "#cb4b16",
      text: "#a2a3a4",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  return (
    <DataTable
      // title={`Manage Notes (Private)`}
      className="clickable cms-data-table"
      onRowClicked={(row) => handleView(row)}
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handleLimitChange}
      onChangePage={handlePageChange}
      progressPending={loading}
      progressComponent={<TableLoader noOfColumn={columns.length} />}
      fixedHeader
      fixedHeaderScrollHeight="550px"
      highlightOnHover
      paginationPerPage={10}  // default page size
      paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
      theme={`${theme === "light" ? "light" : "dark"}`}
      customStyles={getCmsDataTableStyles(theme)}
    />
  );
};
